import {
  Component,
  OnInit,
  ViewContainerRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core'
import { Message } from 'primeng/api'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { environment } from '@env/environment'
import { Observable, Subject } from 'rxjs'
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from '@angular/forms'
import { takeUntil } from 'rxjs/operators'

const BASE_PATH = environment.basePath

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
})
export class ChangePasswordComponent implements OnInit {
  
  currentPassword: string
  /**
   * The user name property
   */
  userName: string

  newPassword: string
  
  confirmPassword: string
  /**
   * The form builder
   */
  form: FormGroup
  /**
   * The error/ warning messages to display
   */
  msgs: Message[] = []
  /**
   * @private
   */
  parentContainer: ViewContainerRef
  /**
   * The Subjet emitter object to destroy all the subscriptions
   * when the component is destroyed
   */
  destroy$: Subject<boolean> = new Subject<boolean>()
  /**
   * Display the component or not
   */
  @Output() hideDialog = new EventEmitter<Boolean>()
  /**
   * Display the component or not
   */
  @Input() visible = false

  constructor(private http: HttpClient, private formBuilder: FormBuilder) {}

  /**
  
   * @param abstractControl
   */
  static MatchPassword(abstractControl: AbstractControl) {
    if (
      // tslint:disable-next-line:no-backbone-get-set-outside-model
      abstractControl.get('newPassword').value !==
      // tslint:disable-next-line:no-backbone-get-set-outside-model
      abstractControl.get('confirmPassword').value
    ) {
      // tslint:disable-next-line:no-backbone-get-set-outside-model
      abstractControl.get('confirmPassword').setErrors({ MatchPassword: true })
    } else {
      return null
    }
  }
  /**
   * Initiliazes the form
   */
  ngOnInit() {
    this.form = this.formBuilder.group(
      {
        userName: ['', [Validators.required]],
        currentPassword: ['', [Validators.required]],
        newPassword: ['', [Validators.required]],
        confirmPassword: ['', [Validators.required]],
      },
      {
        validator: ChangePasswordComponent.MatchPassword,
      }
    )
  }
  /**
   * Submit the filled form to a REST service
   */
  submitForm(): void {
    const user = {
      userName: this.form.controls['userName'].value,
      currentPassword: this.form.controls['currentPassword'].value,
      newPassword: this.form.controls['newPassword'].value,
      confirmPassword: this.form.controls['confirmPassword'].value,
    }

    this.changePassword(user)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.msgs = []
          this.msgs.push({
            severity: 'success',
            summary: 'success',
            detail: 'Your password has been changed successfully!',
          })
          this.hide()
        },
        (error) => {
          this.msgs = []
          this.msgs.push({
            severity: 'error',
            summary: 'error',
            detail: 'Please check the mandatory fields',
          })
        }
      )
  }

  /**
   
   
   * @returns {Observable}
   */
  changePassword(credential): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    })
    const body = new HttpParams({
      fromObject: {
        username: credential.userName,
        oldPassword: credential.currentPassword,
        newPassword: credential.newPassword,
      },
    })
    return this.http.post(`${BASE_PATH}/security/changePassword`, body, {
      headers,
    })
  }

  
  isValidPassword() {
    return (
      (this.form.controls['confirmPassword'].value === '' &&
        this.form.controls['newPassword'].value === '') ||
      (this.form.controls['confirmPassword'].valid &&
        this.form.controls['confirmPassword'].value ===
          this.form.controls['newPassword'].value)
    )
  }
  /**
   * Hides the dialog
   */
  hide() {
    this.form.reset({})
    this.hideDialog.emit(true)
  }
  /**
   * Destroys the component and all the subscriptions
   */
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
